import { render, staticRenderFns } from "./PixSectionModal.vue?vue&type=template&id=6812cd74&scoped=true"
import script from "./PixSectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PixSectionModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PixSectionModal.vue?vue&type=style&index=0&id=6812cd74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812cd74",
  null
  
)

export default component.exports